import { Module, VuexModule, getModule, Mutation } from 'vuex-module-decorators';
import store from '@/store';

@Module({
  namespaced: true,
  name: 'blog',
  store,
  dynamic: true
})

class BlogModule extends VuexModule {

  articles: any[] = [];

  @Mutation
  setArticles(articles: any[]) {

    this.articles = articles;
  }

  
  @Mutation
  addArticles(articles: any[]) {

    this.articles = [...this.articles, ...articles];
  }

}

export default getModule(BlogModule)
